<template>
    <main v-if="init">
        <template v-if="isWeb">
            <router-link to="/user/my-devices" class="back_icon">
                <span class="icon icon-arrow-left-1 "></span>
            </router-link>
        </template>
        <section>
            <DeviceInfoCard
                :deviceInfo="deviceInfo"
            />
        </section>
        <section>
            <SubscriptionCard
                :subDevice="subDevice"
                :subscription="subscription"
                :planInfo="planInfo"
                @refresh="getDeviceInfo"
                :from="'my-devices'"
            />
        </section>
        <AiSwitchSection
            :deviceInfo="deviceInfo"
            :show-ai="subDevice?.aiSupport"
            :subDevice="subDevice"
        />
    </main>
</template>

<script lang="ts">
import { EPlatform } from '@/api/app';
import { getPlanById } from '@/api/cart';
import { getDeviceList } from '@/api/cloud';
import { getSubDeviceList, getSubscriptionById } from '@/api/subscriptions';
import { unfoldError } from '@/common/js/notice';
import { getYmhFromQuery } from '@/common/js/query';
import { IGetPlanByIdRes, IPlan, IReolinkDevice, ISubDevice, ISubscription } from '@reolink-cloud/interface';
import { Async } from '@reolink-web/utils';
import { config } from 'CONFIG';
import nProgress from 'nprogress';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import DeviceInfoCard from './components/DeviceInfoCard.vue';
import SubscriptionCard from './components/SubscriptionCard.vue';
import AiSwitchSection from './components/AiSwitchSection.vue';
import store from '@/store';

export default Vue.extend({
    components: {
        SubscriptionCard,
        DeviceInfoCard,
        AiSwitchSection
    },
    async created() {

        try {

            await Promise.all( [
                this.getDeviceInfo(),
                await store.dispatch( 'initGetCMKS' )
            ] );

        } catch ( e ) {

            console.error( e );
            unfoldError( 'errors.server_error' );

        }

    },
    mounted() {

        nProgress.done();

    },
    computed: {
        ...mapGetters( ['lang', 'country'] as const ),
        isWeb(): boolean {

            return config.client === EPlatform.Web;

        },
    },
    data() {

        return {
            deviceInfo: {} as IReolinkDevice,
            subDevice: undefined as ISubDevice | undefined,
            subscription: undefined as ISubscription | undefined,
            planInfo: undefined as IPlan | undefined,
            init: false,
        };

    },
    methods: {
        async getDeviceInfo() {

            const uid = getYmhFromQuery( this.$route );

            const [deviceList, subDeviceList] = await Promise.all( [
                getDeviceList(),
                getSubDeviceList(),
            ] );
            const device = deviceList.find( item => item.uid === uid );
            const subDevice = subDeviceList.find( item => item.uid === uid );
            if ( !device ) {

                unfoldError( 'errors.server_error' );
                setTimeout(() => {

                    Async.invokeAsync( async () => {

                        await this.$router.push({ path: '/user/my-devices' });

                    });

                }, 1000 );
                return;

            }
            this.deviceInfo = device;
            this.subDevice = subDevice;
            if ( subDevice && subDevice.status === 'associated' ) {

                let planAndSeries: IGetPlanByIdRes;
                [this.subscription, planAndSeries] = await Promise.all( [
                    getSubscriptionById( subDevice.subscription ),
                    getPlanById( subDevice.plan, this.lang )
                ] );
                if ( this.subscription.status === 'inactive' ) {

                    this.subscription = undefined;

                }
                planAndSeries.plan.title = planAndSeries.series.i18n.name;
                planAndSeries.plan.series = planAndSeries.series;
                this.planInfo = planAndSeries.plan;

            }

            this.init = true;

        },

    }
});
</script>

<style lang="less" scoped>
main{
    max-width: 528px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 68px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media @mobile{
        padding: 0 20px;
        margin: 20px auto;
        gap: 16px;
    }
    .icon{
        font-size: 20px;
        color: @black;
        &:hover{
            color: @b_6;
        }
    }
}
</style>
